// message types
export const WELCOME_MESSAGE = 'welcome';
export const EMAIL_MESSAGE = 'email';
export const BUTTON_MOBILE_MESSAGE = 'button-mobile';
export const BUTTON_DESKTOP_MESSAGE = 'button-desktop';
